import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import ScrollToTop from './ScrollToTop';
import Home from './components/Home';
import Work from './pages/Work';
import Services from './pages/Services';
import About from './pages/About';
import Blog from './pages/Blog';
import Contact from './pages/Contact';
import BlogDashboard from './pages/admin/BlogDashboard';
import ProjectsDashboard from './pages/admin/ProjectsDashboard';
import ProjectDetails from './pages/ProjectDetails';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Error404Page from './pages/Error404Page';
import BlogDetails from './pages/BlogDetails';
import PricingPage from './pages/PricingPage';
import ProtectedRoute from './components/ProtectedRoute';

const router = createBrowserRouter([
  { path: '/', element: <Home /> },
  { path: '/work', element: <Work /> },
  { path: '/work/:id', element: <ProjectDetails /> },
  { path: '/services', element: <Services /> },
  { path: '/about', element: <About /> },
  { path: '/blog', element: <Blog /> },
  { path: '/blog/:id', element: <BlogDetails /> },
  { path: '/contact', element: <Contact /> },
  { 
    path: '/admin/blog', 
    element: (
      <ProtectedRoute>
        <BlogDashboard />
      </ProtectedRoute>
    )
  },
  { 
    path: '/admin/projects', 
    element: (
      <ProtectedRoute>
        <ProjectsDashboard />
      </ProtectedRoute>
    )
  },
  { path: '/privacy-policy', element: <PrivacyPolicy /> },
  { path: '/terms-of-service', element: <TermsOfService /> },
  { path: '/pricing', element: <PricingPage /> }, // Add the PricingPage route
  { path: '*', element: <Error404Page /> },
]);

function App() {
  return (
    <div className="min-h-screen bg-perspective-ink overflow-x-hidden w-full">
      <RouterProvider router={router}>
        {/* ScrollToTop must be rendered within RouterProvider */}
        <ScrollToTop />
      </RouterProvider>
    </div>
  );
}

export default App;
